module.exports = __webpack_public_path__ + "static/img/s7.5ffafc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorporateTravel/s7.png
// module id = dCfz
// module chunks = 1